export var isArray = function (value) {
    return value && typeof value === 'object' ? toString.call(value) === '[object Array]' : false;
};
export var isObject = function (value) {
    return value && typeof value === 'object' ? toString.call(value) === '[object Object]' : false;
};
export var Constants = {
    RS_FOR: 'rsfor',
    RS_IF: 'rsif',
    RS_SORT: 'rssort',
    RS_OF: 'rsof',
    RS_SHOW: 'rsshow',
    MODEL: 'model',
    DELETE_TAG: 'delete_tag',
    SORT_DESC: 'DESC',
    SELECTED: 'selected',
    CHECKED: 'checked',
    RS_INPUT_FILTER: 'rsinputfilter',
    DATA_RS_INPUT_FILTER: 'data-rsinputfilter',
    RS_DATA: 'rsdata',
    RS_MONITOR: 'rsmonitor',
    DATA_RS_MONITOR: 'data-rsmonitor',
};
export var ErrorConstants = {
    RSIF_SYNTAXT_ERROR: 'Error in template rsIf syntax',
    RSFOR_SYNTAXT_ERROR: 'Error in template rsFor syntax',
    RSOF_SYNTAXT_ERROR: 'Error in template rsOf syntax',
    RSSORT_SYNTAXT_ERROR: 'Error in template rsSort syntax',
};
//# sourceMappingURL=util.js.map